Auth = require 'db/auth'
BusinessClassSelectOrgView = undefined
queueRequire -> BusinessClassSelectOrgView = require 'views/organization/business-class-select-org-view'
ConfirmEmailView = undefined
queueRequire -> ConfirmEmailView = require 'views/confirm-email/confirm-email-view'
ErrorView = undefined
queueRequire -> ErrorView = require 'views/error/error-view'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
Member = undefined
queueRequire -> Member = require 'models/member'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
SearchInputView = undefined
queueRequire -> SearchInputView = require 'views/search/search-input-view'
SearchState = undefined
queueRequire -> SearchState = require 'view-models/search-state'
Util = require 'lib/util'
safeReturnUrl = require 'lib/util/url/safe-return-url'
$ = require 'jquery'
l = require 'lib/localize'
log = require 'debug/log'
_ = require 'underscore'
templates = require 'views/internal/templates'

module.exports =
  routes: [
    ['shortcuts', 'shortcutsView']
    ['shortcuts/overlay', 'shortcutsViewOverlay']
    ['blank', 'blankView']
    ['select-org-to-upgrade', 'businessClassSelectOrgView']
    ['select-team-to-upgrade', 'businessClassSelectTeamView']
    ['search(?*query)', 'searchView']
    ['confirm-email(?confirmReturnUrl=:confirmReturnUrl)', 'confirmEmailView']
  ]

  businessClassSelectOrgView: ->
    @navigate '/select-team-to-upgrade', replace: true, trigger: true
    return

  businessClassSelectTeamView: ->
    pathname = '/select-team-to-upgrade'

    if !Auth.isLoggedIn()
      window.location = "/login?returnUrl=#{ pathname }"
      return

    Promise.using @getSpinner(), =>
      ModelLoader.for('top-level', 'loadMyOrganizations').then (member) =>
        @setViewType('select-org')

        notPremiumOrgs = _.filter(member.organizationList.models, (org) -> !org.isPremium())
        if notPremiumOrgs.length == 1
          @navigate "/#{ notPremiumOrgs[0].get('name') }/billing", { trigger: true }
          return

        @setLocation
          title: l('select organization to upgrade to business class')
          location: pathname

        @clearPreviousView()
        view = @topLevelView(BusinessClassSelectOrgView, member)

        @showHeader()
        $('#content').html view.render().el
    .done()

  searchView: ->
    log('controller', ['searchView'])

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        if !Auth.isLoggedIn()
          @displayErrorPage()
          return

        @setViewType('search')
        @clearPreviousView()
        me = Auth.me()
        headerCache = ModelCache

        query = Util.getQueryParameter('q', "")
        inputView = @topLevelView(SearchInputView, me, modelCache: headerCache)
        resultsView = inputView.getResultsView()

        SearchState.setQuery(query)
        resultsView.update()
        @showHeader({ noSearch: true })

        $('#classic-body').addClass('body-search-page')

        $('#content')
        .append(inputView.render().el)
        .append(resultsView.render().el)

        _.defer -> inputView.focusInput()
        return
    .done()

  blankView: ->
    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('blank')
        @clearPreviousView()
        @showHeader()
        return
    .done()

  shortcutsViewOverlay: ->
    ModelLoader.waitFor 'headerData', =>
      title = l('keyboard shortcuts')
      location = 'shortcuts/overlay'

      if @onAnyBoardView()
        @saveBoardsView()
        Dialog.show
          html: templates.fill('shortcuts')
          maxWidth: 550
          hide: (isNavigating) =>
            if !isNavigating
              @loadBoardsView()
        @setLocation(title, location)
      else
        @navigate '/shortcuts', replace: true, trigger: true

    return

  shortcutsView: ->
    ModelLoader.waitFor 'headerData', =>
      title = l('keyboard shortcuts')
      location = 'shortcuts'

      if @onAnyBoardView()
        @navigate '/shortcuts/overlay', replace: true, trigger: true
      else
        @staticView {
          title
          location
          bodyClass: 'body-single-column'
          template: -> templates.fill('shortcuts')
        }

    return

  errorView: ({ title, location, data }) ->
    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('error')
        @clearPreviousView()
        @showHeader()

        errorView = @topLevelView(ErrorView, data)
        $('#content').append(errorView.render().el)
        @focusContent()

        @setLocation({ title, location })
    .done()

  staticView: ({ title, location, template, templateData, bodyClass, viewType, headerOpts }) ->

    log('controller', [location + 'View'])

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType(viewType ? location)
        @clearPreviousView()
        @showHeader(headerOpts)

        template(templateData)
      .then (html) =>
        $('#classic-body').addClass(bodyClass)
        $('#content').html(html)
        @focusContent()

        @setLocation({ title, location })
    .done()

  confirmEmailView: (confirmReturnUrl)  ->
    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        confirmReturnUrl = safeReturnUrl Util.getQueryParameter('confirmReturnUrl', '/')

        if Auth.confirmed()
          return @navigate confirmReturnUrl, { trigger: true }

        @clearPreviousView()
        @setViewType('confirm-email')
        @title('Confirm Your Email')
        view = @topLevelView(ConfirmEmailView, Auth.me(), { confirmReturnUrl })
        $('#classic-body').addClass('body-single-column body-hide-header')
        $('#content').html(view.render().el)
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/other-routes.coffee